import React, { useState } from 'react';
import Measure from 'react-measure';
import Reply from '../Reply';
const ReplyWrap = ({ mid, content, nofix, emoticonInfo, handleEmoticon, onExpand }) => {
    const [width, setWidth] = useState();
    return (React.createElement(Measure, { bounds: true, onResize: contentRect => {
            var _a;
            setWidth((_a = contentRect.bounds) === null || _a === void 0 ? void 0 : _a.width);
        } }, ({ measureRef }) => {
        var _a;
        return (React.createElement("div", { ref: measureRef, style: Object.assign({ flex: '0 0 auto' }, (nofix ? { height: '64px' } : { zIndex: 9 })) }, ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder) === 2 ? ('') : (React.createElement("div", { className: nofix ? 'u-read-reply' : 'u-read-fixed', style: { width: nofix ? '100%' : width } },
            React.createElement(Reply, { mid: mid, mailContent: content, emoticonInfo: emoticonInfo, handleEmoticon: handleEmoticon, onExpand: onExpand })))));
    }));
};
export default ReplyWrap;
